<template>
  <div class="container-fluid container-wrap col-sm-12 col-xs-12">
    <div style="margin-top: 28px"></div>
    <!-- 페이지 헤더 영역 -->
    <div class="card-header pb-0 col-sm-12 d-flex">
      <div class="col-sm-12 col-xs-12">
        <div class="col-sm-12 col-xs-12 justify-content-between titleContainer">
          <div class="title-row">
            <h1 class="fw-bold page-title">
              이벤트 참여 관리
            </h1>
            <div class="header-actions">
              <!-- 이벤트 선택은 참여 현황 모니터링 탭의 필터에서 관리 -->
            </div>
          </div>
          <span class="pageDesc">이벤트 참여자의 활동을 모니터링하고 독려 메시지를 발송할 수 있습니다.</span>
        </div>
      </div>
    </div>
    
    <!-- 콘텐츠 영역 -->
    <div class="card-body px-0 pt-3 pb-2">
      <!-- 참여자 관리 탭 -->
      <div class="card content-wrap-card">
        <a-tabs v-model:activeKey="activeTab" @change="handleTabChange">
          <a-tab-pane key="monitoring" tab="모니터링">
            <ParticipantMonitoring 
              :participants="filteredParticipants"
              :loading="loading"
              :event-list="mockEvents"
              :selected-event-id="selectedEventId"
              @filter-change="handleFilterChange"
              @event-change="handleEventChange"
            />
          </a-tab-pane>

          <!-- 메시지 효과성 추적 탭 주석처리 -->
          <!--
          <a-tab-pane key="effectiveness" tab="메시지 효과성 추적">
            <MessageEffectivenessTracker
              :event-id="selectedEventId"
              :event-list="mockEvents"
            />
          </a-tab-pane>
          -->

          <a-tab-pane key="analytics" tab="분석">
            <EnhancedAnalytics
              :event-id="selectedEventId"
            />
          </a-tab-pane>

          <a-tab-pane key="report" tab="레포트">
            <EventReportTab />
          </a-tab-pane>

          <a-tab-pane key="activity" tab="활동분석(deprecated)">
            <ActivityAnalysis
              :event-id="selectedEventId"
            />
          </a-tab-pane>

          <!-- 추후 구현 예정 탭들 -->
          <!--
          <a-tab-pane key="realtime" tab="실시간 퍼널 분석" disabled>
            <div class="preparing-content">
              <a-empty description="준비중입니다. 더 정교한 분석을 위해 개선 중입니다." />
            </div>
          </a-tab-pane>
          
          <a-tab-pane key="message" tab="독려 메시지 관리" disabled>
            <div class="preparing-content">
              <a-empty description="준비중입니다." />
            </div>
          </a-tab-pane>
          
          <a-tab-pane key="schedule" tab="자동 발송 설정" disabled>
            <div class="preparing-content">
              <a-empty description="준비중입니다." />
            </div>
          </a-tab-pane>
          -->
        </a-tabs>
      </div>
    </div>

  </div>
</template>

<script>
import { ref, computed, onMounted, provide } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import ParticipantMonitoring from './components/participation/ParticipantMonitoring.vue';
import ActivityAnalysis from './components/participation/ActivityAnalysis.vue';
import EnhancedAnalytics from './components/participation/EnhancedAnalytics.vue';
import EventReportTab from './components/participation/report/EventReportTab.vue';
// import MessageEffectivenessTracker from './components/participation/MessageEffectivenessTracker.vue';
// 추후 구현 예정 컴포넌트들
// import MessageManagement from './components/participation/MessageManagement.vue';
// import AutoScheduleSettings from './components/participation/AutoScheduleSettings.vue';
// import RealTimeFunnel from './components/participation/RealTimeFunnel.vue';

export default {
  name: 'EventParticipationManage',
  components: {
    ParticipantMonitoring,
    ActivityAnalysis,
    EnhancedAnalytics,
    EventReportTab
    // MessageEffectivenessTracker
  },
  setup() {
    const route = useRoute();
    const router = useRouter();

    // 유효한 탭 키 목록
    const validTabs = ['monitoring', 'analytics', 'report', 'activity'];

    // 상태 관리
    const selectedEventId = ref(''); // 첫 번째 이벤트가 자동으로 선택됨
    const activeTab = ref('monitoring'); // 첫 번째 탭으로 변경 (기본값)
    
    // 자식 컴포넌트에 selectedEventId 제공
    provide('selectedEventId', selectedEventId);
    const loading = ref(false);
    const currentFilter = ref('all');

    // 이벤트 목록은 ParticipantMonitoring 컴포넌트에서 API로 직접 로드
    const mockEvents = ref([]);

    // 임시 데이터 - 참여자 목록
    const participants = ref([
      {
        id: 'p001',
        name: '김철수',
        phone: '010-1234-5678',
        email: 'kim@example.com',
        hospital: '서울대학교병원',
        status: 'shared',
        sharedAt: '2024-01-15 14:23:00',
        couponReceived: false,
        loggedIn: false,
        lastActivity: '2024-01-15 14:23:00'
      },
      {
        id: 'p002',
        name: '이영희',
        phone: '010-2345-6789',
        email: 'lee@example.com',
        hospital: '연세대학교병원',
        status: 'coupon_received',
        sharedAt: '2024-01-14 10:15:00',
        couponReceived: true,
        loggedIn: false,
        couponReceivedAt: '2024-01-14 10:30:00',
        lastActivity: '2024-01-14 10:30:00'
      },
      {
        id: 'p003',
        name: '박민수',
        phone: '010-3456-7890',
        email: 'park@example.com',
        hospital: '삼성서울병원',
        status: 'logged_in',
        sharedAt: '2024-01-13 09:00:00',
        couponReceived: true,
        loggedIn: true,
        couponReceivedAt: '2024-01-13 09:15:00',
        loggedInAt: '2024-01-13 09:20:00',
        lastActivity: '2024-01-13 09:20:00'
      },
      {
        id: 'p004',
        name: '정수진',
        phone: '010-4567-8901',
        email: 'jung@example.com',
        hospital: '서울아산병원',
        status: 'participated',
        sharedAt: null,
        couponReceived: false,
        loggedIn: false,
        lastActivity: '2024-01-12 15:00:00'
      },
      // 더 많은 참여자 데이터 추가
      ...Array.from({ length: 50 }, (_, i) => ({
        id: `p${String(i + 5).padStart(3, '0')}`,
        name: `참여자${i + 5}`,
        phone: `010-${String(Math.floor(Math.random() * 10000)).padStart(4, '0')}-${String(Math.floor(Math.random() * 10000)).padStart(4, '0')}`,
        email: `user${i + 5}@example.com`,
        hospital: ['서울대학교병원', '연세대학교병원', '삼성서울병원', '서울아산병원'][Math.floor(Math.random() * 4)],
        status: ['participated', 'shared', 'coupon_received', 'logged_in'][Math.floor(Math.random() * 4)],
        sharedAt: Math.random() > 0.3 ? '2024-01-15 ' + String(Math.floor(Math.random() * 24)).padStart(2, '0') + ':' + String(Math.floor(Math.random() * 60)).padStart(2, '0') + ':00' : null,
        couponReceived: Math.random() > 0.5,
        loggedIn: Math.random() > 0.7,
        lastActivity: '2024-01-' + String(Math.floor(Math.random() * 15) + 1).padStart(2, '0') + ' ' + String(Math.floor(Math.random() * 24)).padStart(2, '0') + ':' + String(Math.floor(Math.random() * 60)).padStart(2, '0') + ':00'
      }))
    ]);

    // 임시 데이터 - 메시지 템플릿
    const messageTemplates = ref([
      {
        id: 'tpl001',
        name: '공유 독려 메시지',
        content: '#{name}님, 친구들과 함께 이벤트를 즐겨보세요! 지금 공유하시면 추가 혜택이 있어요. 🎁',
        platform: 'alimtalk',
        variables: ['name'],
        category: 'share_encouragement'
      },
      {
        id: 'tpl002',
        name: '쿠폰 수령 독려',
        content: '#{name}님의 커피 쿠폰이 기다리고 있어요! ☕ 놓치기 전에 지금 바로 받아가세요.',
        platform: 'alimtalk',
        variables: ['name'],
        category: 'coupon_encouragement'
      },
      {
        id: 'tpl003',
        name: '로그인 독려',
        content: '#{name}님, 로그인하시면 더 많은 혜택을 받을 수 있어요! 간편하게 로그인해보세요.',
        platform: 'alimtalk',
        variables: ['name'],
        category: 'login_encouragement'
      }
    ]);

    // 임시 데이터 - 발송 이력
    const sendHistory = ref([
      {
        id: 'h001',
        sentAt: '2024-01-15 10:00:00',
        template: '공유 독려 메시지',
        targetCount: 150,
        successCount: 148,
        failCount: 2,
        conversionCount: 45,
        conversionRate: 30.4
      },
      {
        id: 'h002',
        sentAt: '2024-01-14 15:00:00',
        template: '쿠폰 수령 독려',
        targetCount: 200,
        successCount: 198,
        failCount: 2,
        conversionCount: 87,
        conversionRate: 43.9
      }
    ]);

    // 임시 데이터 - 자동 발송 스케줄
    const autoSchedules = ref([
      {
        id: 'sch001',
        name: '공유 미참여자 독려',
        condition: '이벤트 참여 후 24시간 내 미공유',
        template: '공유 독려 메시지',
        delayHours: 24,
        enabled: true
      },
      {
        id: 'sch002',
        name: '쿠폰 미수령자 독려',
        condition: '공유 후 48시간 내 미수령',
        template: '쿠폰 수령 독려',
        delayHours: 48,
        enabled: false
      }
    ]);

    // 필터링된 참여자
    const filteredParticipants = computed(() => {
      if (currentFilter.value === 'all') return participants.value;
      
      return participants.value.filter(p => {
        switch (currentFilter.value) {
          case 'no_share':
            return p.status === 'participated';
          case 'no_coupon':
            return p.status === 'shared';
          case 'no_login':
            return p.status === 'coupon_received';
          default:
            return true;
        }
      });
    });

    // 메서드
    const handleTabChange = (key) => {
      console.log('Tab changed:', key);
      // 쿼리 파라미터 업데이트 (기존 파라미터 유지하면서 tab만 변경)
      router.replace({
        query: {
          ...route.query,
          tab: key
        }
      });
    };

    const handleFilterChange = (filter) => {
      currentFilter.value = filter;
    };

    const handleSaveSchedule = (schedule) => {
      console.log('Saving schedule:', schedule);
      // 스케줄 저장 로직
    };
    
    const handleEventChange = (eventId) => {
      selectedEventId.value = eventId;
      console.log('Event changed to:', eventId);
      // 이벤트 변경 시 데이터 재조회 로직 추가
    };

    onMounted(() => {
      console.log('이벤트 참여 관리 페이지 로드됨');

      // 쿼리 파라미터에서 eventId 확인
      if (route.query.eventId) {
        selectedEventId.value = route.query.eventId;
        console.log('Query parameter eventId:', route.query.eventId);
        // selectedEventId가 설정되면 ParticipantMonitoring의 watchEffect가 자동으로 처리
      }

      // 쿼리 파라미터에서 tab 확인 (유효한 탭인 경우에만 적용)
      if (route.query.tab && validTabs.includes(route.query.tab)) {
        activeTab.value = route.query.tab;
        console.log('Query parameter tab:', route.query.tab);
      }
    });

    return {
      selectedEventId,
      activeTab,
      loading,
      mockEvents,
      participants,
      filteredParticipants,
      messageTemplates,
      sendHistory,
      autoSchedules,
      handleTabChange,
      handleFilterChange,
      handleSaveSchedule,
      handleEventChange
    };
  }
};
</script>

<style scoped lang="scss">
/* ===========================================
   반응형 브레이크포인트 정의
   - PC: 1200px 이상
   - 태블릿: 768px ~ 1199px
   - 모바일: 767px 이하
   =========================================== */
$breakpoint-mobile: 767px;
$breakpoint-tablet: 1199px;

@mixin mobile {
  @media screen and (max-width: $breakpoint-mobile) {
    @content;
  }
}

@mixin tablet {
  @media screen and (min-width: 768px) and (max-width: $breakpoint-tablet) {
    @content;
  }
}

@mixin tablet-and-below {
  @media screen and (max-width: $breakpoint-tablet) {
    @content;
  }
}

@mixin pc {
  @media screen and (min-width: 1200px) {
    @content;
  }
}

.page-title {
  font-size: 24px;
  font-weight: 700;
  margin: 0;

  @include tablet {
    font-size: 22px;
  }

  @include mobile {
    font-size: 20px;
  }
}

.pageDesc {
  font-size: 14px;
  color: #6c757d;
  margin-top: 8px;
  display: block;

  @include mobile {
    font-size: 13px;
    margin-top: 6px;
  }
}

.title-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;

  @include mobile {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
}

.header-actions {
  display: flex;
  gap: 12px;

  @include mobile {
    width: 100%;
    justify-content: flex-start;
  }
}

.content-wrap-card {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  margin-bottom: 20px;

  @include mobile {
    border-radius: 0;
    margin-left: -12px;
    margin-right: -12px;
    box-shadow: none;
  }
}

/* 탭 스타일 */
:deep(.ant-tabs-tab) {
  padding: 12px 20px;
  font-size: 15px;

  @include tablet {
    padding: 10px 16px;
    font-size: 14px;
  }

  @include mobile {
    padding: 8px 12px;
    font-size: 13px;
  }
}

/* 모바일에서 탭 가로 스크롤 */
:deep(.ant-tabs-nav) {
  @include mobile {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;

    &::-webkit-scrollbar {
      display: none;
    }
  }
}

:deep(.ant-tabs-nav-list) {
  @include mobile {
    flex-wrap: nowrap;
  }
}

:deep(.ant-tabs-content) {
  padding: 20px;

  @include tablet {
    padding: 16px;
  }

  @include mobile {
    padding: 12px;
  }
}

/* 컨테이너 반응형 패딩 */
.container-wrap {
  @include mobile {
    padding-left: 12px !important;
    padding-right: 12px !important;
  }
}

.card-header {
  @include mobile {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
}

/* 준비중 콘텐츠 */
.preparing-content {
  padding: 60px 0;
  text-align: center;

  @include mobile {
    padding: 40px 0;
  }
}
</style>